import { type MeetingTemplate } from '../store/ai/meetingTemplate'

export interface MeetingTemplateOptionFlags {
  isCurrent: boolean
  isLegacy: boolean
  isNewVersion: boolean
}

export const getMeetingTemplateOptionFlags = ({
  optionId,
  currentTemplate,
  allTemplates,
}: {
  optionId: string
  currentTemplate: Pick<MeetingTemplate, 'id' | 'isDeprecated' | 'newMeetingTemplateId'> | null | undefined
  allTemplates: ReadonlyArray<Pick<MeetingTemplate, 'id' | 'isDeprecated'>>
}): MeetingTemplateOptionFlags => {
  const currentIsDeprecated = currentTemplate?.isDeprecated === true
  return {
    isCurrent: currentTemplate?.id === optionId,
    isLegacy: allTemplates.find((mt) => mt.id === optionId)?.isDeprecated === true,
    isNewVersion: currentIsDeprecated && optionId === currentTemplate?.newMeetingTemplateId,
  }
}
